module.exports = __webpack_public_path__ + "static/img/logo.90edfb93.png";